import React from 'react';
import { Divider, Empty, Tag } from 'antd';
import { createUseStyles } from 'react-jss'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { CollectionServer, JSXMap, POST, QueryDetail, errorCatch, updateInArray } from 'fennec-ui'

import { DropdownAction } from 'fennec-ui'

import NovoeZasedaniePravleniyaFederatsii from '../../forms/NovoeZasedaniePravleniyaFederatsii'
import ZasedaniyaPravleniyaFederatsii from '../../forms/ZasedaniyaPravleniyaFederatsii'

import PageLayout from '../../components/PageLayout';

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

const useStyles = createUseStyles({
    modal: {
        '& .ant-modal-title': {
            marginRight: "25px"
        }
    },
    divider: {
        '&.ant-divider-horizontal.ant-divider-with-text-left': {
            fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
            fontSize: "13px",
            fontWeight: "400",
            color: "rgb(0, 0, 0)",
        },
        '&.ant-divider-horizontal.ant-divider-with-text-left .ant-divider-inner-text': {
            padding: "0px",
            marginRight: "10px",
        }
    },
    block: {
        '& .buttons': {
            marginBottom: "10px"
        },
        // '& .buttons .ant-btn': {
        //     border: "none",
        //     '-webkit-box-shadow': "none",
        //     'box-shadow': "none"
        // }
    },
    actionTitle: {
        marginBottom: "5px"
    }
})

export default function FederationdministratorFederalgovernmentGeneral(props) {
    const classes = useStyles();
    const { auth } = props;
    const filters = () => [
        {
            label: "Дата",
            display: item => item.dataZasedaniya,
            name: "dataZasedaniya",
            type: "date",
            sort: true,
            filter: true,
            sorted: "DESC"
        },
        {
            label: "Номер протокола",
            display: item => item.nomerProtokolaZasedaniya,
            name: "nomerProtokolaZasedaniya",
            type: "string",
            sort: true,
            filter: true
        },
        {
            label: "Место проведения",
            display: item => item.mestoProvedeniyaZasedaniya.name,
            name: "mestoProvedeniyaZasedaniya",
            type: "string",
            sort: true,
            filter: true
        },
        {
            label: "Статус",
            display: item => item.tekushchiiStatusZasedaniya.opisanie,
            name: "tekushchiiStatusZasedaniya",
            type: "string",
            sort: true,
            filter: true
        },
    ];
    const badge = (record, index) => {
        if (record.tekushchiiStatusZasedaniyaID == 1) return (<Tag color={'blue'}>{record.tekushchiiStatusZasedaniya.opisanie}</Tag>);
        else if (record.tekushchiiStatusZasedaniyaID == 2) return (<Tag color={'geekblue'}>{record.tekushchiiStatusZasedaniya.opisanie}</Tag>);
        else if (record.tekushchiiStatusZasedaniyaID == 3) return (<Tag color={'green'}>{record.tekushchiiStatusZasedaniya.opisanie}</Tag>);
        else if (record.tekushchiiStatusZasedaniyaID == 4) return (<Tag color={'gold'}>{record.tekushchiiStatusZasedaniya.opisanie}</Tag>);
        else if (record.tekushchiiStatusZasedaniyaID == 5) return (<Tag>{record.tekushchiiStatusZasedaniya.opisanie}</Tag>);
        else return (<Tag>{record.tekushchiiStatusZasedaniya.opisanie}</Tag>);
    }
    return (
        <PageLayout>
            <div style={{ backgroundColor: "white", borderRadius: "4px" }}>
                <div style={{ padding: "10px" }}>
                    <div>
                        <Divider className={classes.divider} type="horizontal" orientation="left">
                            Заседания правления федерации
                        </Divider>
                        <CollectionServer
                            name={"ZasedaniyaPravleniyaFederatsii"}
                            auth={auth}
                            contextFilters={() => [
                                QueryDetail("model")
                            ]}
                            filters={filters}
                            mode={"list"}
                            customRender={(items, {
                                collection,
                                setCollection,
                                setCollectionItem,
                                removeCollectionItem,
                                collectionActions,
                                modelActions,
                                update
                            }) => (<div>
                                {(items?.length <= 0) && <div><Empty description={"Нет данных"} style={{ padding: "40px 0px" }} /></div>}
                                {JSXMap(items, (item, idx) => {
                                    return (<div key={item.ID} className="item" style={{ display: "flex", justifyContent: "space-between", width: "100%", padding: "8px 0px" }}>
                                        <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                            <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
                                                <div style={{ display: "flex", justifyContent: "flex-start", gap: "5px" }}>
                                                    <div className='bg bg-grey' style={{ fontWeight: "600" }}>№{item.nomerProtokolaZasedaniya} </div>
                                                    <div>{dayjs(item.dataZasedaniya).tz("Europe/Moscow").format('DD.MM.YYYY HH:mm')}</div>
                                                </div>
                                                <div style={{ color: "#7c7c7c", fontWeight: "400", fontSize: "12px" }}>
                                                    <span>Место проведения: {item.mestoProvedeniyaZasedaniya.name}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            {badge(item)}
                                        </div>
                                        {modelActions && <div onClick={(e) => { e.stopPropagation() }}>
                                            <DropdownAction
                                                style={{ padding: "0 8px 0 0" }}
                                                button={() => (<div className={`bg bg-grey pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                                    <i className="fa fa-ellipsis-h"></i>
                                                </div>)}
                                                items={modelActions(item, idx)?.map((e, idx) => ({
                                                    key: e.key || idx,
                                                    auth: auth,
                                                    mode: "MenuItem",
                                                    object: item,
                                                    collection: collection,
                                                    setCollection: setCollection,
                                                    ...e
                                                }))} />
                                        </div>}
                                    </div>)
                                })}
                            </div>)}
                            collectionActions={() => [
                                {
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        POST(auth, `/api/novoezasedaniepravleniyafederatsii`, values,
                                            ({ data }) => {
                                                setCollection(updateInArray(collection, data, true));
                                                close();
                                            }, (err) => errorCatch(err, unlock)
                                        );
                                    },
                                    form: NovoeZasedaniePravleniyaFederatsii,
                                    title: "Новое заседание",
                                    modal: {
                                        width: "600px",
                                        title: "Новое заседание правления федерации",
                                    }
                                }
                            ]}
                            modelActions={(item) => [
                                {
                                    readonly: true,
                                    modal: { title: "Заседание правления федерации", width: "65%" },
                                    object: item,
                                    mode: "MenuItem",
                                    action: (values, unlock, close, { collection, setCollection }) => { },
                                    title: "Просмотр",
                                    form: ZasedaniyaPravleniyaFederatsii
                                }
                            ]}
                        />
                    </div>
                </div>
            </div>
        </PageLayout>
    );
}
